import { API, tokenRefreshTime } from '../../shared/constants/constants';

let refreshTokenTimeoutId = null;
let refreshTimerEnabled = false;

function scheduleNextRefresh() {
  if (typeof window === 'undefined' || !refreshTimerEnabled) {
    return;
  }

  if (refreshTokenTimeoutId !== null) {
    window.clearTimeout(refreshTokenTimeoutId);
  }

  refreshTokenTimeoutId = window.setTimeout(refreshTokenHandler, tokenRefreshTime);
}

export function refreshToken() {
  return new Promise((resolve, reject) => {
    const refreshTokenValue = sessionStorage.getItem('refresh_token');

    if (!refreshTokenValue) {
      resolve(false);
      return;
    }

    console.log('refreshing token!');

    API.post('/user/refresh', {
      refresh_token: refreshTokenValue,
    })
      .then((response) => {
        const tokens = JSON.parse(response.data.tokens) || null;

        if (tokens) {
          sessionStorage.setItem('id_token', tokens.id_token);
          sessionStorage.setItem('access_token', tokens.access_token);
          resolve(true);
        } else {
          sessionStorage.removeItem('access_token');
          sessionStorage.removeItem('id_token');
          sessionStorage.removeItem('refresh_token');
          resolve(false);
        }
      })
      .catch((err) => {
        console.error('Authorization error. Please try again.');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('refresh_token');
        resolve(false);
      });
  });
}

export function stopRefreshTokenTimer() {
  refreshTimerEnabled = false;

  if (refreshTokenTimeoutId !== null && typeof window !== 'undefined') {
    window.clearTimeout(refreshTokenTimeoutId);
    refreshTokenTimeoutId = null;
  }
}

export function startRefreshTokenTimer() {
  if (typeof window === 'undefined') {
    return;
  }

  refreshTimerEnabled = true;
  scheduleNextRefresh();
}

export async function refreshTokenHandler() {
  if (!refreshTimerEnabled) {
    return;
  }

  const revalidated = await refreshToken();

  if (!refreshTimerEnabled) {
    return;
  }

  if (revalidated) {
    // Call the function every 45 minutes to get a new token
    scheduleNextRefresh();
  } else {
    stopRefreshTokenTimer();
    window.location.replace(process.env.REACT_APP_COGNITO_URL);
  }
}
